import { render, staticRenderFns } from "./OtoSearch.vue?vue&type=template&id=4dce567e"
import script from "./OtoSearch.vue?vue&type=script&lang=js"
export * from "./OtoSearch.vue?vue&type=script&lang=js"
import style0 from "./OtoSearch.vue?vue&type=style&index=0&id=4dce567e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports